import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from 'components/button';

// Styles
import styles from './flyoutButton.scss';

/**
 * React component for FlyoutButton.
 */
class FlyoutButton extends React.Component {
  /**
   * Component constructor
   * @param {object} props - This component's props.
   */
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.toggleFlyout = this.toggleFlyout.bind(this);
  }

  /**
   * Reverse the isOpen state.
   */
  toggleFlyout() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  }

  /**
   * Render the component.
   * @return {XML} - JSX for component.
   */
  render() {
    const {
      children,
      label,
      type,
    } = this.props;
    const { isOpen } = this.state;
    return (
      <div className={styles.flyoutButton}>
        <Button
          action={this.toggleFlyout}
          label={label}
          type={type}
        />
        <div
          className={isOpen ? styles.openFlyout : styles.closedFlyout}
        >
          {children}
        </div>
      </div>
    );
  }
}

FlyoutButton.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default FlyoutButton;



// WEBPACK FOOTER //
// ./app/components/flyoutButton/index.js